import React, { useState } from 'react';
import { Link, Menu } from 'tdesign-react';
import styles from './index.module.scss';
import { ArrowLeftIcon } from 'tdesign-icons-react/lib/icons';

const { HeadMenu } = Menu;

const MenuKey = {
  Product: 'product',
  Solution: 'solution',
  Developer: 'developer'
};

const Header: React.FC = () => {
  const [active, setActive] = useState(MenuKey.Product);

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.headerMiddleBox}>
        <HeadMenu
          className={styles.header}
          theme="light"
          value={active}
          onChange={(v: any) => setActive(v)}
          logo={
            <h1 className={styles.internalTitle}>
              <Link hover="color" href="/#/product">
                <ArrowLeftIcon className={styles.backIcon} />
                腾讯私有化软件下载中心
              </Link>
            </h1>
          }
          operations={null}
        />
      </div>
    </div>
  );
};

export default Header;
